import React from 'react';
import { Button, ButtonProps } from '../ui/button';
import { cn } from '../../lib/utils';
import { ArrowRight } from 'lucide-react';

interface ButtonPrimaryProps extends ButtonProps {
    showArrow?: boolean;
}

export const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
    className,
    showArrow,
    children,
    ...props
}) => {
    return (
        <Button
            variant="default"
            size="lg"
            className={cn("w-full h-[50px] text-[15px] font-semibold", className)}
            {...props}
        >
            {children}
            {showArrow && !props.isLoading && (
                <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
            )}
        </Button>
    );
};
